import api from './axios';

export const getCostReport = (params) => api.get('/reports/cost', { params });
export const getUsageReport = (params) => api.get('/reports/usage', { params });
